import jwtDecode from "jwt-decode";

const HARDCODED_TOKEN = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJiZWEwODRmMS1iOWI0LTQ2ZGEtYjZiZi1kNDg1YjE2YWJjZGQiLCJuYW1lIjoiQXJlZWogWmFoaWQgQWxpIiwiaW1hZ2UiOiJodHRwczovL3dvcmt3LmNvbS9SZXNvdXJjZXNcXDBhYjVmOWMwLWY5NDgtNGM0MC04ZGFkLWM1OGJhOTlmYjc2NVxcSW1hZ2VzXFxiZGM2YmM1NC0wNjAwLTQxOGYtYTM0OS1mMDIyMWRhYjU2MGYuanBlZyIsImVtYWlsIjoiYXJlZWpAbWlsZXRhcC5jb20iLCJidXNpbmVzc0lkIjoiMGFiNWY5YzAtZjk0OC00YzQwLThkYWQtYzU4YmE5OWZiNzY1IiwidmVyIjoiODIzODlFQkMtMDA1OS00NEUzLUI1QjUtMUM0REU0NzcwQ0E1IiwiaWgiOiJJVVNDK2phZDc3VENTWDJJbUhiSnhTK2hjY0Y0dGg2UVcvc2tobmdiRkZFPSIsImlzIjoiSExCSnlUMHpuL2tiZUVuMUcrZWVGQT09IiwicGgiOiI3VTduMEhzZi9BczNNYjU0c2hVYnB3UmNrRVU3c0JXTUN0Q2IrTmJObEpjPSIsInBzIjoiMGFCVTdNMGo1RURhN1J6WGQyUngzQT09IiwiaXNBZ2VudCI6IkZhbHNlIiwianRpIjoiMDFlZDc0YjMtYjkxYS00NjdlLWEzNjctYzI1NWUwMmM5NzM4IiwibmJmIjoxNzcyMTg0ODQxLCJleHAiOjE3NzIzNTc2NDF9.Oo-pJcp6BVYsVjr7qnzr2Lr23d4ADMFpBVDmPTenhNAa-VGv1BqN59bprMMGjACYjYwgGp_5T0OCzjYwrqX16x_I4PsZW_n9JKztOk-0uXukdiIXPWfXyt1mWqmAJHfIXz9e7Efxd_0JhAakcYyZCnQ5x67_SH7r5U2BekmJU6uSYMenFyY9KufisscilDd5x-ccvklj4jyxJje5rHiPDECs5IO_lZB0lZWpR0I27Z9IXHOfgFVP7Vdeopk0Ym4ltpouWeKJsk0MOHM1svQza0WQbXWKFNSu6l-4LrxzvO6HXTtG_-Gmz5K-3olrkEcUHjE6C7jYrdyHkpIPgrDq5g";

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    return match[2];
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue("token");
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || HARDCODED_TOKEN;
  return finalToken;
}

export function decodeWorkWiseToken() {
  const token = getWorkWiseAuthToken();
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
}

export const getUserInfoFromToken = () => {
  try {
    const token = getWorkWiseAuthToken();

    if (!token) return null;

    const decoded = jwtDecode(token);

    return decoded || null;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};
